module.exports = __webpack_public_path__ + "static/media/mail.0c4793cb.svg";